import { useState } from "react";
import { Breadcrumb, PageHeader, Stepper, Tabs } from "@maeiz/ui";
import { DocPage, Section, Demo, SpecTable } from "../../components/DocChrome";

export function NavigationPage() {
    const [step, setStep] = useState(1);

    return (
        <DocPage
            title="Navigation"
            description="One navigation language: shell, breadcrumbs, tabs, steppers."
        >
            <Section title="Stepper wizard">
                <Demo className="space-y-4">
                    <Stepper
                        steps={[
                            { id: "plan", title: "Choose Plan", description: "Select tier" },
                            {
                                id: "details",
                                title: "Organization",
                                description: "Company & admin",
                            },
                            { id: "security", title: "Security", description: "Password & pay" },
                        ]}
                        currentStep={step}
                        onStepClick={setStep}
                    />
                </Demo>
            </Section>

            <Section title="Breadcrumbs & Tabs">
                <Demo>
                    <Breadcrumb
                        items={[
                            { label: "Customers", href: "#" },
                            { label: "Al-Noor", href: "#" },
                            { label: "History" },
                        ]}
                    />
                    <div className="mt-6">
                        <PageHeader title="Customers" subtitle="Area-filtered list" />
                    </div>
                    <Tabs
                        tabs={[
                            {
                                id: "all",
                                label: "All",
                                content: (
                                    <p className="text-sm text-neutral-secondary">All customers</p>
                                ),
                            },
                            {
                                id: "active",
                                label: "Active",
                                content: <p className="text-sm">Active only</p>,
                            },
                        ]}
                        activeTabId="all"
                        onTabChange={() => undefined}
                    />
                </Demo>
            </Section>
            <Section title="When to use">
                <SpecTable
                    rows={[
                        ["AppShell sidebar", "Owner / Tenant desktop"],
                        ["BottomNav", "Rider / Customer mobile"],
                        ["Breadcrumb", "Detail depth ≥ 2"],
                        ["Tabs", "Peer views of same entity"],
                        ["Stepper", "Wizards (onboarding, checkout)"],
                    ]}
                />
            </Section>
        </DocPage>
    );
}
